// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'unindent';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='m14.188 8.561-2.126-2.125 2.126-2.125M9.406 3.249H1.97m7.436 3.187H1.97m7.436 3.188H1.97m13.811 3.187H1.97m13.811 3.187H1.97m15.936-9.562h-5.844'
  />
);

export const viewBox = '0 0 18 18';
